<template>
  <div class="Changepassword">
    <van-nav-bar title="修改密码" left-arrow fixed placeholder @click-left="onClickLeft" />
    <van-form @submit="submits()" label-width='2rem' label-align='center'>
      <div class="password">
        <label>原始密码</label>
        <van-field v-model="passwordList.oldpassword" placeholder="请输入原始密码" type="password"
          :rules="[{pattern: passwordRules, message: '请输入6-12位密码' }]" class="pass-input" />
        <label class="m70">新的密码</label>
        <van-field v-model="passwordList.password" placeholder="请输入新的密码" type="password"
          :rules="[{pattern: passwordRules, message: '请输入6-12位密码' }]" />
        <label>确认新的密码</label>
        <van-field v-model="passwordList.passwords" placeholder="请确认新的密码" type="password"
          :rules="[{ validator, message: '两次密码不一致' }]" />
      </div>
      <van-button type="primary" block color="#2DADB1" native-type="submit">提交</van-button>
    </van-form>
    <p>忘记密码，请联系后台管理员。</p>
  </div>
</template>

<script>
import { modifyPass } from '@/api/user.js'
export default {
  name: 'changepassword',
  props: {},
  data () {
    return {
      value: '',
      oldErrorMessage: '',
      passwordList: {
        oldpassword: '',
        password: '',
        passwords: ''
      },
      passwordRules: /^[\w]{6,12}$/,
      oldshow: false,
      passhow: false,
      newpasshow: false
    }
  },
  methods: {
    onClickLeft () {
      this.$router.back()
    },
    // 验证第二次输入的新密码
    validator (val) {
      if (val != this.passwordList.password) {
        return false
      }
    },
    async submits () {
      try {
        const data = await modifyPass(this.passwordList)
        if (data.error_code === 1) {
          this.$toast('密码修改成功,请重新登录!')
          window.localStorage.removeItem('token')
          this.$store.commit('setUser', '')
          window.localStorage.removeItem('userInfo')
          this.$store.commit('setUserInfo', '')
          setTimeout(() => {
            this.$router.push('/login')
          }, 2000)
        } else {
          this.$toast(data.msg)
        }
      } catch (error) {
        return error.message;
      }
    }
  },
}
</script>

<style scoped lang="less">
.Changepassword {
  height: 100%;
  background-color: #f8f8f8;
  .password {
    width: 60%;
    margin: 60px auto 0;
    label {
      font-size: 26px;
      color: #666666;
    }

    /deep/ .van-cell {
      padding: 0;
    }
  }
  /deep/ .van-button--block {
    width: 500px;
    margin: 80px auto;
  }
  p {
    font-size: 26px;
    color: #666666;
    text-align: center;
  }
}
</style>
